<template>
  <div class="app-modal" :class="{ open: item.isOpen, dragging: isDragging }" :style="dragPopupStyle">
    <div ref="popupRef" v-click-outside="() => item.showHandleBar && handleClose()" class="app-modal-safe">
      <div class="modal-wrap">
        <div v-if="item.showHandleBar" class="md-handle" @mousedown="startDrag" @touchstart.prevent="startDrag">
          <span></span>
        </div>

        <div v-if="item.showCloseButton" class="close-modal-wrap">
          <button type="button" class="modal-close" @click="handleClose">
            <img :src="getAssetImageUrl('common/icons/close.svg')" alt="close" />
          </button>
        </div>

        <div class="modal-con">
          <h1 v-if="item.title" class="modal-tit">
            <component :is="titleNode" v-if="titleNode" />
            <template v-else>{{ item.title }}</template>
          </h1>
          <component
            :is="item.contentSlot"
            :payload="item.payload"
            :refresh="item.refresh"
            @confirm="handleConfirm"
            @close="handleClose"
          />
        </div>

        <div v-if="item.confirmButton?.text" class="btn-area">
          <button type="button" class="primary-btn l-btn" @click="handleConfirm">
            <span>{{ item.confirmButton?.text }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { isVNode } from 'vue';

import { useHandleBar } from '@/composables/domains/mobile/useHandleBar';
import { usePopupStore } from '@/stores/popup';
import { PopupItem } from '@/types/components';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const props = defineProps<{ item: PopupItem }>();

const popupStore = usePopupStore();

const popupContainerRef = ref<HTMLElement | null>(null);
const popupRef = ref<HTMLElement | null>(null);

const titleNode = computed(() => {
  return isVNode(props.item.title) ? () => props.item.title : null;
});

const handleClose = () => {
  popupStore.close(props.item.id);
};

const handleConfirm = (...args: unknown[]) => {
  props.item.confirmButton?.action?.(...args);
};

const { isDragging, dragPopupStyle, startDrag } = useHandleBar(
  computed(() => props.item.isOpen),
  handleClose,
  popupRef
);
</script>

<style scoped lang="scss">
.app-modal {
  transform: translateY(100%);
  transition: transform 0.4s cubic-bezier(0.32, 0.72, 0, 1);

  &.open {
    transform: translateY(0);
  }

  &.dragging {
    transition: none;
  }

  &::before {
    content: '';
    position: absolute;
    height: 100%;
    background: $color-transparent-dark60;
    left: 0;
    bottom: 100%;
    right: 0;
  }
}

.md-handle {
  cursor: grab;
  touch-action: none;

  &:active {
    cursor: grabbing;
  }

  span {
    transition:
      background 0.2s,
      width 0.2s;
  }
}

.close-modal-wrap {
  padding: 1rem 0 0.5rem;
  display: flex;
  justify-content: flex-end;
  .modal-close {
    padding: $size-xs;
  }
  .btn-area {
    margin-top: 1.5rem;
    width: 100%;
  }
}
</style>
